export default "__VITE_ASSET__C3unmt_U__"